import { supabase } from "@/integrations/supabase/client";

export async function getInvitedGuests(collectionId: string) {
  const { data, error } = await supabase
    .from("invited_guests" as any)
    .select("*")
    .eq("collection_id", collectionId)
    .order("created_at", { ascending: true });
  return { data: (data || []) as unknown as { id: string; collection_id: string; email: string; created_at: string }[], error };
}

export async function addInvitedGuest(collectionId: string, email: string) {
  const { data, error } = await supabase
    .from("invited_guests" as any)
    .insert({ collection_id: collectionId, email: email.toLowerCase().trim() })
    .select()
    .single();
  return { data, error };
}

export async function removeInvitedGuest(id: string) {
  const { error } = await supabase
    .from("invited_guests" as any)
    .delete()
    .eq("id", id);
  return { error };
}

export async function isUserInvited(collectionId: string, email: string) {
  const { data, error } = await supabase
    .from("invited_guests" as any)
    .select("id")
    .eq("collection_id", collectionId)
    .eq("email", email.toLowerCase().trim())
    .maybeSingle();
  return { invited: !!data, error };
}
